import { createSlice } from "@reduxjs/toolkit";
import { agreementValidation } from "../components/validations/Agreement";
import { alertNotificationValidation } from "../components/validations/AlertNotificationCreation";
import { blackListValidation } from "../components/validations/BlackListCreation";
import { clusterValidation } from "../components/validations/ClusterCreation";
import { CustomerShipperValidation } from "../components/validations/CustomerShipperCreation";
import {
  approveHeaderValidation,
  deductionFuelValidation,
  deductionMasterValidation,
  fuelAddValidation,
  itemCreationValidation,
} from "../components/validations/DeductionCreation";
import { employeeValidation } from "../components/validations/EmployeeCreation";
import {
  exchangeHeaderValidations,
  exchangeRateValidations,
} from "../components/validations/ExchangeRateCreation";
import { rateValidation } from "../components/validations/RateManager";
import { shiftAssignValidation } from "../components/validations/ShiftAssignmentCreation";
import { shiftDetailsValidation } from "../components/validations/ShiftCreation";
import { shiftGroupValidation } from "../components/validations/ShiftGroupCreation";
import { stakeholderGroupValidation } from "../components/validations/StakeholderGroupCreation";
import {
  stakeholderVehicleTypeCustomerValidation,
  stakeholderVehicleTypeShipperValidation,
  stakeholderVehicleValidation,
} from "../components/validations/StakeholderVehicleCreation";
import { trailersMasterValidation } from "../components/validations/TrailersCreation";
import { policeDivisionValidation } from "../components/validations/PoliceDivisionCreation";
import { bankBranchValidation } from "../components/validations/BankBranchCreation";
import { UserCustomerValidation } from "../components/validations/UserCustomerCreation";
import { userCustomerGroupValidation } from "../components/validations/UserCustomerGroupValidation";
import {
  locationContactValidation,
  locationValidation,
} from "../components/validations/locationCreation";
import {
  validateRequestInitiation,
  validateRequestTransport,
} from "../components/validations/validateRequestCreation";
import { vehicleValidation } from "../components/validations/vehicleCreation";
import { supplierInvoiceValidation } from "../components/validations/SupplierInvoice";
import {
  workOrderCreationValidation,
  workOrderValidation,
} from "../components/validations/WorkOrderCreation";
import {supplierPaymentHoldValidation} from "../components/validations/SupplierPaymentHoldCreation";
import {fuelRequestValidation} from "../components/validations/FuelRequestCreation";

const initialState = {
  stakeholderErrors: {
    stakeholderErrors: {},
    contactErrors: {},
    clusterErrors: {},
    typeErrors: {},
    checkupErrors: {},
    financeErrors: {},
    alertErrors: {},
    operationTypeErrors: {},
    configurationErrors: {},
    documentUploadErrors: {},
    submitErrors: {},
    hasErrors: false,
    consignmentErrors: {},
  },
  exchangeHeaderErrors: {
    exchangeHeaderErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  vehicleErrors: {
    vehicleErrors: {},
    opertionErrors: {},
    typeErrors: {},
    checkupErrors: {},
    accidentErrors: {},
    documentUploadErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  employeeErrors: {
    employeeErrors: {},
    contactErrors: {},
    documentUploadErrors: {},
    alertErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  agreementErrors: {
    agreementErrors: {},
    documentUploadErrors: {},
    submitErrors: {},
    hasErrors: false,
  },

  supplierInvoiceErrors: {
    supplierInvoiceErrors: {},
    documentUploadErrors: {},
    submitErrors: {},
    hasErrors: false,
  },

  blackListErrors: {
    blackListErrors: {},
    documentUploadErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  clusterErrors: {
    clusterErrors: {},
    alertErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  rateMasterErrors: {
    rateMasterErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  requestCreationErrors: {
    requestErrors: {},
    transportErrors: {},
    locationErrors: {},
    summaryErrors: {},
    otherErrors: {},
    documentUploadErrors: {},
    hasErrors: false,
  },
  stakeholderGroupErrors: {
    stakeholderGroupErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  userCustomerErrors: {
    userCustomerErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  customerShipperErrors: {
    customerShipperErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  stakeholderVehicleTypeCusErrors: {
    stakeholderVehicleTypeCusErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  stakeholderVehicleTypeShpErrors: {
    stakeholderVehicleTypeShpErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  deductItemCreationErrors: {
    deductItemCreationErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  workOrderErrors: {
    workOrderErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  deductApprovalHeaderErrors: {
    deductApprovalHeaderErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  deductApprovalDetailErrors: {
    deductApprovalDetailErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  locationCreationErrors: {
    locationErrors: {},
    contactErrors: {},
    locationCustomerErrors: {},
    locationProviderErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  approvalProcessErrors: {
    approvalProcessErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  deductMasterErrors: {
    deductMasterErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  trailersMaterErrors: {
    trailersMaterErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  policeDivisionErrors: {
    policeDivisionErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  bankBranchErrors: {
    bankBranchErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  shiftDetailsErrors: {
    shiftDetailsErrors: {},
    usersErrors: {},
    submitErrors: {},
    hasErrors: false,
  },

  requestSchedulerErrors: {
    requestSchedulerErrors: {},
    submitErrors: {},
    hasErrors: false,
  },

  shiftGroupErrors: {
    shiftGroupErrors: {},
    shiftGroupUserErrors: {},
    shiftGroupCompaniesErrors: {},
    submitErrors: {},
    hasErrors: false,
  },

  shiftAssignmentErrors: {
    shiftAssignmentErrors: {},
    shiftAssignmentActionErrors: {},
    shiftStakeholderErrors: {},
    shiftUserErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  deviceCurrentActionErrors: {
    deviceCurrentActionErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  userCustomerGroupErrors: {
    userCustomerGroupErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  alertDefaultErrors: {
    alertDefaultErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  optionConfigErrors: {
    optionConfigErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
  bankMasterErrors: {
    bankMasterErrors: {},
    hasErrors: false,
  },
  fuelRequestErrors: {
    fuelRequestErrors: {},
    submitErrors: {},
    hasErrors: false,
  },
};

const errorSlice = createSlice({
  name: "error",
  initialState,
  reducers: {
    validateStakeholder(state, action) {
      // const stakeholderErrors = stakeholderValidation(
      //   action.payload.stakeholderData,
      // );
      const stakeholderErrors = action.payload.stakeholderFormErrors;
      // const financeErrors = financeInfoValidation(action.payload.financeData);
      const financeErrors = action.payload.financeFormErrors;
      return {
        ...state,
        stakeholderErrors: {
          ...state.stakeholderErrors,
          stakeholderErrors,
          financeErrors,
          hasErrors: true,
        },
      };
    },
    addStakeholderErrorObject(state, action) {
      return {
        ...state,
        stakeholderErrors: {
          ...state.stakeholderErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    addStakeholderError(state, action) {
      return {
        ...state,
        stakeholderErrors: {
          ...state.stakeholderErrors,
          [action.payload.form]: {
            ...state.stakeholderErrors[action.payload.form],
            [action.payload.key]: action.payload.value,
          },
          hasErrors: action.payload.value ? true : false,
        },
      };
    },
    clearStakeholderError(state, action) {
      return {
        ...state,
        stakeholderErrors: initialState.stakeholderErrors,
      };
    },
    validateVehicle(state, action) {
      const vehicleErrors = vehicleValidation(action.payload.vehicleData, action.payload.inspectionTimeOpt);
      return {
        ...state,
        vehicleErrors: {
          ...state.vehicleErrors,
          vehicleErrors,
          hasErrors: true,
        },
      };
    },
    addVehicleErrorObject(state, action) {
      const hasPayloadErrors = action.payload.errors && Object.keys(action.payload.errors).length > 0;
      return {
        ...state,
        vehicleErrors: {
          ...state.vehicleErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: hasPayloadErrors,
        },
      };
    },
    addVehicleError(state, action) {
      return {
        ...state,
        vehicleErrors: {
          ...state.vehicleErrors,
          [action.payload.form]: {
            ...state.vehicleErrors[action.payload.form],
            [action.payload.key]: action.payload.value,
          },
          hasErrors: action.payload.value ? true : false,
        },
      };
    },
    clearVehicleError(state, action) {
      return {
        ...state,
        vehicleErrors: initialState.vehicleErrors,
        hasErrors: false,
      };
    },
    validateEmployee(state, action) {
      const empErrors = employeeValidation(action.payload.employeeData);
      return {
        ...state,
        employeeErrors: {
          ...state.employeeErrors,
          employeeErrors: empErrors,
          hasErrors: true,
        },
      };
    },
    addEmployeeErrorObject(state, action) {
      const hasPayloadErrors = action.payload.errors && Object.keys(action.payload.errors).length > 0;
      return {
        ...state,
        employeeErrors: {
          ...state.employeeErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: hasPayloadErrors,
        },
      };
    },
    addEmployeeError(state, action) {
      return {
        ...state,
        employeeErrors: {
          ...state.employeeErrors,
          [action.payload.form]: {
            ...state.employeeErrors[action.payload.form],
            [action.payload.key]: action.payload.value,
          },
          hasErrors: action.payload.value ? true : false,
        },
      };
    },
    clearEmployeeError(state, action) {
      return {
        ...state,
        employeeErrors: initialState.employeeErrors,
      };
    },
    validateAgreement(state, action) {
      const agrErrors = agreementValidation(action.payload.agreementData);
      return {
        ...state,
        agreementErrors: {
          ...state.agreementErrors,
          agreementErrors: agrErrors,
          hasErrors: true,
        },
      };
    },
    addAgreementErrorObject(state, action) {
      return {
        ...state,
        agreementErrors: {
          ...state.agreementErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    addAgreementError(state, action) {
      return {
        ...state,
        agreementErrors: {
          ...state.agreementErrors,
          [action.payload.form]: {
            ...state.agreementErrors[action.payload.form],
            [action.payload.key]: action.payload.value,
          },
          hasErrors: action.payload.value ? true : false,
        },
      };
    },
    clearAgreementError(state, action) {
      return {
        ...state,
        agreementErrors: initialState.agreementErrors,
      };
    },

    validateSupplierInvoice(state, action) {
      const supplierInvErro = supplierInvoiceValidation(
        action.payload.supplierInvoiceData,
      );
      return {
        ...state,
        supplierInvoiceErrors: {
          ...state.supplierInvoiceErrors,
          supplierInvoiceErrors: supplierInvErro,
          hasErrors: true,
        },
      };
    },

    addSupplierInvoiceErrorObject(state, action) {
      return {
        ...state,
        supplierInvoiceErrors: {
          ...state.supplierInvoiceErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },

    addSupplierInvoiceError(state, action) {
      return {
        ...state,
        supplierInvoiceErrors: {
          ...state.supplierInvoiceErrors,
          [action.payload.form]: {
            ...state.supplierInvoiceErrors[action.payload.form],
            [action.payload.key]: action.payload.value,
          },
          hasErrors: action.payload.value ? true : false,
        },
      };
    },

    clearSupplierInvoiceError(state, action) {
      return {
        ...state,
        supplierInvoiceErrors: initialState.supplierInvoiceErrors,
      };
    },

    validateBlackList(state, action) {
      const blackListErrors = blackListValidation(action.payload.blackListData);
      return {
        ...state,
        blackListErrors: {
          ...state.blackListErrors,
          blackListErrors: blackListErrors,
          hasErrors: true,
        },
      };
    },
    addBlackListErrorObject(state, action) {
      return {
        ...state,
        blackListErrors: {
          ...state.blackListErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    addBlackListError(state, action) {
      return {
        ...state,
        blackListErrors: {
          ...state.blackListErrors,
          [action.payload.key]: action.payload.value,
          hasErrors: action.payload.value ? true : false,
        },
      };
    },
    clearBlackListError(state, action) {
      return {
        ...state,
        blackListErrors: initialState.blackListErrors,
      };
    },
    validateExchangeHeader(state, action) {
      const exhErrors = exchangeHeaderValidations(
        action.payload.exchangeHeaderData,
      );
      console.log("exhErrors");
      console.log(exhErrors);
      return {
        ...state,
        exchangeHeaderErrors: {
          ...state.exchangeHeaderErrors,
          exchangeHeaderErrors: exhErrors,
          hasErrors: true,
        },
      };
    },
    validateExchangeRate(state, action) {
      const excErrors = exchangeRateValidations(
        action.payload.exchangeRateData,
      );
    },
    clearExcHeaderError(state, action) {
      return {
        ...state,
        exchangeHeaderErrors: initialState.exchangeHeaderErrors,
      };
    },
    validateCluster(state, action) {
      const cluErrors = clusterValidation(action.payload.clusterData);
      return {
        ...state,
        clusterErrors: {
          ...state.clusterErrors,
          clusterErrors: cluErrors,
          hasErrors: true,
        },
      };
    },
    addClusterErrorObject(state, action) {
      return {
        ...state,
        clusterErrors: {
          ...state.clusterErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    addClusterError(state, action) {
      return {
        ...state,
        clusterErrors: {
          ...state.clusterErrors,
          [action.payload.key]: action.payload.value,
          hasErrors: action.payload.value ? true : false,
        },
      };
    },
    clearClusterError(state, action) {
      return {
        ...state,
        clusterErrors: initialState.clusterErrors,
      };
    },
    validateRateMaster(state, action) {
      const rateErr = rateValidation(action.payload.rateData);
      return {
        ...state,
        rateMasterErrors: {
          ...state.rateMasterErrors,
          rateErrors: action.payload.rateErrors,
          hasErrors: Object.entries(rateErr).length > 0 ? true : false,
        },
      };
    },
    addRateMasterErrorObject(state, action) {
      return {
        ...state,
        rateMasterErrors: {
          ...state.rateMasterErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    addRateMasterError(state, action) {
      return {
        ...state,
        rateMasterErrors: {
          ...state.rateMasterErrors,
          [action.payload.form]: {
            ...state.rateMasterErrors[action.payload.form],
            [action.payload.key]: action.payload.value,
          },
          hasErrors: action.payload.value ? true : false,
        },
      };
    },
    clearRateMasterError(state, action) {
      return {
        ...state,
        rateMasterErrors: initialState.rateMasterErrors,
      };
    },
    validateRequestCreation(state, action) {
      const requestErrors = validateRequestInitiation(
        action.payload.requestData,
      );
      const transportErrors = validateRequestTransport(
        action.payload.transportData,
      );
      return {
        ...state,
        requestCreationErrors: {
          ...state.requestCreationErrors,
          requestErrors: action.payload.requestErrors,
          transportErrors: action.payload.transportErrors,
          hasErrors:
            Object.entries(requestErrors).length > 0 ||
            Object.entries(transportErrors).length > 0
              ? true
              : false,
        },
      };
    },

    addRequestCreationErrorObject(state, action) {
      return {
        ...state,
        requestCreationErrors: {
          ...state.requestCreationErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    addRequestCreationError(state, action) {
      return {
        ...state,
        requestCreationErrors: {
          ...state.requestCreationErrors,
          [action.payload.form]: {
            ...state.requestCreationErrors[action.payload.form],
            [action.payload.key]: action.payload.value,
          },
          hasErrors: action.payload.value ? true : false,
        },
      };
    },
    clearRequestCreationError(state, action) {
      return {
        ...state,
        requestCreationErrors: initialState.requestCreationErrors,
      };
    },
    validateStakeholderGroup(state, action) {
      const stkErrors = stakeholderGroupValidation(
        action.payload.stakeholderGroupRequest,
      );
      return {
        ...state,
        stakeholderGroupErrors: {
          ...state.stakeholderGroupErrors,
          stakeholderGroupErrors: stkErrors,
          hasErrors: true,
        },
      };
    },
    addStakeholderGroupErrorObject(state, action) {
      return {
        ...state,
        stakeholderGroupErrors: {
          ...state.stakeholderGroupErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    addStakeholderGroupError(state, action) {
      return {
        ...state,
        stakeholderGroupErrors: {
          ...state.stakeholderGroupErrors,
          [action.payload.key]: action.payload.value,
          hasErrors: action.payload.value ? true : false,
        },
      };
    },
    clearStakeholderGroupError(state, action) {
      return {
        ...state,
        stakeholderGroupErrors: initialState.stakeholderGroupErrors,
      };
    },
    validateLocationCreation(state, action) {
      const locErrors = locationValidation(action.payload.locationData);
      const contactErrors = locationContactValidation(
        action.payload.contactData,
      );
      return {
        ...state,
        locationCreationErrors: {
          ...state.locationCreationErrors,
          locationErrors: locErrors,
          contactErrors: contactErrors,
          hasErrors: true,
        },
      };
    },
    addLocationCreationErrorObject(state, action) {
      return {
        ...state,
        locationCreationErrors: {
          ...state.locationCreationErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    addLocationCreationError(state, action) {
      return {
        ...state,
        locationCreationErrors: {
          ...state.locationCreationErrors,
          [action.payload.form]: {
            ...state.locationCreationErrors[action.payload.form],
            [action.payload.key]: action.payload.value,
          },
          hasErrors: action.payload.value ? true : false,
        },
      };
    },
    clearLocationCreationError(state, action) {
      return {
        ...state,
        locationCreationErrors: initialState.locationCreationErrors,
      };
    },
    validateUserCustomer(state, action) {
      const uscErrors = UserCustomerValidation(action.payload.userCustomerData);
      return {
        ...state,
        userCustomerErrors: {
          ...state.userCustomerErrors,
          userCustomerErrors: uscErrors,
          hasErrors: true,
        },
      };
    },
    clearUserCustomerError(state, action) {
      return {
        ...state,
        userCustomerErrors: initialState.userCustomerErrors,
      };
    },

    validateCustomerShipper(state, action) {
      const cshErrors = CustomerShipperValidation(
        action.payload.customerShipperData,
      );
      return {
        ...state,
        customerShipperErrors: {
          ...state.customerShipperErrors,
          customerShipperErrors: cshErrors,
          hasErrors: true,
        },
      };
    },
    clearCustomerShipperError(state, action) {
      return {
        ...state,
        customerShipperErrors: initialState.customerShipperErrors,
      };
    },

    validateStakeholderVehicleTypeCus(state, action) {
      const stkVehErrors = stakeholderVehicleTypeCustomerValidation(
        action.payload.stakeholderVehTypeData,
      );
      return {
        ...state,
        stakeholderVehicleTypeCusErrors: {
          ...state.stakeholderVehicleTypeCusErrors,
          stakeholderVehicleTypeCusErrors: stkVehErrors,
          hasErrors: true,
        },
      };
    },
    clearStakeholderVehicleTypeCusError(state, action) {
      return {
        ...state,
        stakeholderVehicleTypeCusErrors:
          initialState.stakeholderVehicleTypeCusErrors,
      };
    },

    validateStakeholderVehicleTypeShp(state, action) {
      const stkVehErrors = stakeholderVehicleTypeShipperValidation(
        action.payload.stakeholderVehTypeData,
      );
      return {
        ...state,
        stakeholderVehicleTypeShpErrors: {
          ...state.stakeholderVehicleTypeShpErrors,
          stakeholderVehicleTypeShpErrors: stkVehErrors,
          hasErrors: true,
        },
      };
    },
    clearStakeholderVehicleTypeShpError(state, action) {
      return {
        ...state,
        stakeholderVehicleTypeShpErrors:
          initialState.stakeholderVehicleTypeShpErrors,
      };
    },

    validateStakeholderVehicle(state, action) {
      const stkVehErrors = stakeholderVehicleValidation(
        action.payload.stakeholderVehData,
      );
      return {
        ...state,
        stakeholderVehicleErrors: {
          ...state.stakeholderVehicleErrors,
          stakeholderVehicleErrors: stkVehErrors,
          hasErrors: true,
        },
      };
    },
    clearStakeholderVehicleError(state, action) {
      return {
        ...state,
        stakeholderVehicleErrors: initialState.stakeholderVehicleErrors,
      };
    },

    validateDeductItemCreation(state, action) {
      const deductItemErrors = itemCreationValidation(
        action.payload.deductItemData,
      );
      return {
        ...state,
        deductItemCreationErrors: {
          ...state.deductItemCreationErrors,
          deductItemCreationErrors: deductItemErrors,
          hasErrors: true,
        },
      };
    },
    addDeductItemErrorObject(state, action) {
      return {
        ...state,
        deductItemCreationErrors: {
          ...state.deductItemCreationErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    clearDeductItemError(state, action) {
      return {
        ...state,
        deductItemCreationErrors: initialState.deductItemCreationErrors,
      };
    },

    validateDeductApprovalHeaderCreation(state, action) {
      const deductApprovalHeaderErrors = approveHeaderValidation(
        action.payload.deductAppData,
      );
      return {
        ...state,
        deductApprovalHeaderErrors: {
          ...state.deductApprovalHeaderErrors,
          deductApprovalHeaderErrors: deductApprovalHeaderErrors,
          hasErrors: true,
        },
      };
    },
    addDeductApprovalHeaderErrorObject(state, action) {
      return {
        ...state,
        deductApprovalHeaderErrors: {
          ...state.deductApprovalHeaderErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    clearDeductApprovalHeaderError(state, action) {
      return {
        ...state,
        deductApprovalHeaderErrors: initialState.deductApprovalHeaderErrors,
      };
    },

    validateDeductApprovalDetailCreation(state, action) {
      const deductApprovalDetailErrors = action.payload.deductAppData;
      return {
        ...state,
        deductApprovalDetailErrors: {
          ...state.deductApprovalDetailErrors,
          deductApprovalDetailErrors: deductApprovalDetailErrors,
          hasErrors: true,
        },
      };
    },
    addDeductApprovalDetailErrorObject(state, action) {
      return {
        ...state,
        deductApprovalDetailErrors: {
          ...state.deductApprovalDetailErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    clearDeductApprovalDetailError(state, action) {
      return {
        ...state,
        deductApprovalDetailErrors: initialState.deductApprovalDetailErrors,
      };
    },
    //
    validateApprovalProcessCreation(state, action) {
      const approvalProcessErrors = approveHeaderValidation(
        action.payload.approvalProcessData,
      );
      return {
        ...state,
        approvalProcessErrors: {
          ...state.approvalProcessErrors,
          approvalProcessErrors: approvalProcessErrors,
          hasErrors: true,
        },
      };
    },
    addApprovalProcessErrorObject(state, action) {
      return {
        ...state,
        approvalProcessErrors: {
          ...state.approvalProcessErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    clearApprovalProcessError(state, action) {
      return {
        ...state,
        approvalProcessErrors: initialState.approvalProcessErrors,
      };
    },

    validateDeductMaster(state, action) {
      let deductMasterErrors = deductionMasterValidation(
        action.payload.deductMasterData,
      );
      if (action.payload.deductMasterData.dedItemType === 6) {
        deductMasterErrors = deductionFuelValidation(
          action.payload.deductMasterData,
        );
      }
      return {
        ...state,
        deductMasterErrors: {
          ...state.deductMasterErrors,
          deductMasterErrors: deductMasterErrors,
          hasErrors: true,
        },
      };
    },

    validateAddFuel(state, action) {
      const deductMasterErrors = fuelAddValidation(
        action.payload.deductMasterData,
      );
      console.log("deductMasterErrors", deductMasterErrors);
      return {
        ...state,
        deductMasterErrors: {
          ...state.deductMasterErrors,
          deductMasterErrors: deductMasterErrors,
          hasErrors: true,
        },
      };
    },
    addDeductMasterErrorObject(state, action) {
      return {
        ...state,
        deductMasterErrors: {
          ...state.deductMasterErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    clearDeductMasterError(state, action) {
      return {
        ...state,
        deductMasterErrors: initialState.deductMasterErrors,
      };
    },
    validateTrailers(state, action) {
      const trailerErrors = trailersMasterValidation(
        action.payload.trailerRequest,
      );
      return {
        ...state,
        trailersMaterErrors: {
          ...state.trailersMaterErrors,
          trailersMaterErrors: trailerErrors,
          hasErrors: true,
        },
      };
    },
    clearTrailersError(state, action) {
      return {
        ...state,
        trailersMaterErrors: initialState.trailersMaterErrors,
      };
    },
    validatePoliceDivision(state, action) {
      const pErrors = policeDivisionValidation(
        action.payload.policeDivisionRequest,
      );
      return {
        ...state,
        policeDivisionErrors: {
          ...state.policeDivisionErrors,
          policeDivisionErrors: pErrors,
          hasErrors: true,
        },
      };
    },
    addPoliceDivisionErrorObject(state, action) {
      return {
        ...state,
        policeDivisionErrors: {
          ...state.policeDivisionErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    clearPoliceDivisionError(state, action) {
      return {
        ...state,
        policeDivisionErrors: initialState.policeDivisionErrors,
      };
    },
    validateBankBranch(state, action) {
      const bErrors = bankBranchValidation(
        action.payload.bankBranchRequest
      );
      return {
        ...state,
        bankBranchErrors: {
          ...state.bankBranchErrors,
          bankBranchErrors: bErrors,
          hasErrors: true,
        },
      };
    },
    clearBankBranchError(state, action) {
      return {
        ...state,
        bankBranchErrors: initialState.bankBranchErrors,
      };
    },

    validateShiftDetails(state, action) {
      const shiftDetailsErrors = shiftDetailsValidation(
        action.payload.shiftDetailsData,
      );
      return {
        ...state,
        shiftDetailsErrors: {
          ...state.shiftDetailsErrors,
          shiftDetailsErrors: shiftDetailsErrors,
          hasErrors: true,
        },
      };
    },
    addShiftDetailsErrorObject(state, action) {
      return {
        ...state,
        shiftDetailsErrors: {
          ...state.shiftDetailsErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    clearShiftDetailsError(state, action) {
      return {
        ...state,
        shiftDetailsErrors: initialState.shiftDetailsErrors,
      };
    },

    validateRequestScheduler(state, action) {
      const requestSchErrors = action.payload.schedulerData;
      return {
        ...state,
        requestSchedulerErrors: {
          ...state.requestSchedulerErrors,
          requestSchedulerErrors: requestSchErrors,
          hasErrors: true,
        },
      };
    },
    addRequestScheduleErrorObject(state, action) {
      return {
        ...state,
        requestSchedulerErrors: {
          ...state.requestSchedulerErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },

    clearRequestSchedulerError(state, action) {
      return {
        ...state,
        requestSchedulerErrors: initialState.requestSchedulerErrors,
      };
    },

    validateShiftGroup(state, action) {
      const groupErrors = shiftGroupValidation(action.payload.shiftGroupData);
      return {
        ...state,
        shiftGroupErrors: {
          ...state.shiftGroupErrors,
          shiftGroupErrors: groupErrors,
          hasErrors: true,
        },
      };
    },
    addShiftGroupErrorObject(state, action) {
      return {
        ...state,
        shiftGroupErrors: {
          ...state.shiftGroupErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },

    clearShiftGroupError(state, action) {
      return {
        ...state,
        shiftGroupErrors: initialState.shiftGroupErrors,
      };
    },

    validateShiftAssignment(state, action) {
      const sftAssErrors = shiftAssignValidation(
        action.payload.shiftAssignmentData,
      );
      return {
        ...state,
        shiftAssignmentErrors: {
          ...state.shiftAssignmentErrors,
          shiftAssignmentErrors: sftAssErrors,
          hasErrors: true,
        },
      };
    },
    validateUserCustomerGroup(state, action) {
      const errors = userCustomerGroupValidation(
        action.payload.userCustomerGroupData,
      );
      return {
        ...state,
        userCustomerGroupErrors: {
          ...state.userCustomerGroupErrors,
          userCustomerGroupErrors: errors,
          hasErrors: Object.keys(errors).length > 0,
        },
      };
    },
    addShiftAssignmentErrorObject(state, action) {
      return {
        ...state,
        shiftAssignmentErrors: {
          ...state.shiftAssignmentErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    addShiftAssignmentError(state, action) {
      return {
        ...state,
        shiftAssignmentErrors: {
          ...state.shiftAssignmentErrors,
          [action.payload.form]: {
            ...state.shiftAssignmentErrors[action.payload.form],
            [action.payload.key]: action.payload.value,
          },
          hasErrors: action.payload.value ? true : false,
        },
      };
    },
    clearShiftAssignmentError(state, action) {
      return {
        ...state,
        shiftAssignmentErrors: initialState.shiftAssignmentErrors,
      };
    },

    clearUserCustomerGroupError(state, action) {
      return {
        ...state,
        userCustomerGroupErrors: initialState.userCustomerGroupErrors,
      };
    },

    validateDeviceCurrentAction(state, action) {
      const requestSchErrors = action.payload.schedulerData;
      return {
        ...state,
        deviceCurrentActionErrors: {
          ...state.deviceCurrentActionErrors,
          deviceCurrentActionErrors: requestSchErrors,
          hasErrors: true,
        },
      };
    },
    addDeviceCurrentActionErrorObject(state, action) {
      return {
        ...state,
        deviceCurrentActionErrors: {
          ...state.deviceCurrentActionErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },

    clearDeviceCurrentActionError(state, action) {
      return {
        ...state,
        deviceCurrentActionErrors: initialState.deviceCurrentActionErrors,
      };
    },

    validateAlerts(state, action) {
      const alertErrors = alertNotificationValidation(
        action.payload.alertRequest,
      );
      return {
        ...state,
        alertDefaultErrors: {
          ...state.alertDefaultErrors,
          alertDefaultErrors: alertErrors,
          hasErrors: true,
        },
      };
    },
    clearAlertError(state, action) {
      return {
        ...state,
        alertDefaultErrors: initialState.alertDefaultErrors,
      };
    },

    validateSupplierHold(state, action) {
      const supplierHoldErrors = supplierPaymentHoldValidation(
          action.payload.supplierHoldRequest,
      );
      return {
        ...state,
        supplierHoldErrors: {
          ...state.supplierHoldErrors,
          supplierHoldErrors: supplierHoldErrors,
          hasErrors: true,
        },
      };
    },
    clearSupplierHoldError(state, action) {
      return {
        ...state,
        supplierHoldErrors: initialState.supplierHoldErrors,
      };
    },

    validateOptions(state, action) {
      return {
        ...state,
        optionConfigErrors: {
          ...state.optionConfigErrors,
          optionConfigErrors: action.payload,
          hasErrors: Object.keys(action.payload).length > 0,
        },
      };
    },
    clearOptionError(state) {
      return {
        ...state,
        optionConfigErrors: initialState.optionConfigErrors,
      };
    },
    validateWorkOrder(state, action) {
      const shiftDetailsErrors = workOrderCreationValidation(
        action.payload.workOrderData,
      );
      return {
        ...state,
        workOrderErrors: {
          ...state.workOrderErrors,
          workOrderErrors: shiftDetailsErrors,
          hasErrors: true,
        },
      };
    },
    addWorkOrderErrorObject(state, action) {
      return {
        ...state,
        workOrderErrors: {
          ...state.workOrderErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    clearWorkOrderError(state, action) {
      return {
        ...state,
        workOrderErrors: initialState.workOrderErrors,
      };
    },
    addBankMasterErrorObject(state, action) {
      return {
        ...state,
        bankMasterErrors: {
          ...state.bankMasterErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
        },
      };
    },
    clearBankMasterError(state, action) {
      return {
        ...state,
        bankMasterErrors: initialState.bankMasterErrors,
        hasErrors: false,
      };
    },
    clearError(state, action) {
      // Generic clear error to support Bank.js and any other generic uses
      const formKey = action.payload?.form;
      if (formKey && state[formKey]) {
        return {
          ...state,
          [formKey]: initialState[formKey],
        };
      }
      return state;
    },
    addErrorObject(state, action) {
      // Generic add error object to support Bank.js
      const formKey = action.payload?.form;
      if (formKey && state[formKey]) {
        return {
          ...state,
          [formKey]: {
            ...state[formKey],
            [formKey]: action.payload.errors,
            hasErrors: action.payload.errors && Object.keys(action.payload.errors).length > 0 ? true : false,
          }
        };
      }
      return state;
    },
    validateFuelRequest(state, action) {
      const frqErrors = fuelRequestValidation(
          action.payload.fuelRequestRequest,
          action.payload.formMode,
      );
      return {
        ...state,
        fuelRequestErrors: {
          ...state.fuelRequestErrors,
          fuelRequestErrors: frqErrors,
          hasErrors: true,
        },
      };
    },
    addFuelRequestErrorObject(state, action) {
      return {
        ...state,
        fuelRequestErrors: {
          ...state.fuelRequestErrors,
          [action.payload.form]: action.payload.errors,
          hasErrors: !!action.payload.errors,
        },
      };
    },
    addFuelRequestError(state, action) {
      return {
        ...state,
        fuelRequestErrors: {
          ...state.fuelRequestErrors,
          [action.payload.key]: action.payload.value,
          hasErrors: !!action.payload.value,
        },
      };
    },
    clearFuelRequestError(state, action) {
      return {
        ...state,
        fuelRequestErrors: initialState.fuelRequestErrors,
      };
    },
  },
});

export const errorActions = errorSlice.actions;
export default errorSlice;
